import React, { useEffect, createElement } from 'react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { ContactSection } from '../components/ContactSection';
import { UtmCapture } from '../components/UtmCapture';
import { motion } from 'framer-motion';
import { Wind, Award, ShieldCheck, Rocket, Radio, MapPin, Palmtree, Music, Coffee, Package } from 'lucide-react';
import { Button } from '../components/ui/Button';
export function WingFoilPage() {
  useEffect(() => {
    // Set meta tags for Wing Foil page
    document.title = "Wing Foil - גלيشה וריחוף | ביץ' קלאב מעגן";
    // Update or create meta description
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.setAttribute('name', 'description');
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute('content', 'Wing Foil בכנרת - לעוף מעל המים! חוף מושלם עם רוח צד, הדרכות למתחילים ומתקדמים, ציוד חדיש');
    // Open Graph tags with image
    const ogTags = [{
      property: 'og:title',
      content: "Wing Foil - גלيشה וריחוף | ביץ' קלאב מעגן"
    }, {
      property: 'og:description',
      content: 'Wing Foil בכנרת - הדור הבא של גלيشה. חוף מושלם, הדרכות מקצועיות וציוד חדיש'
    }, {
      property: 'og:type',
      content: 'website'
    }, {
      property: 'og:image',
      content: 'https://uploadthingy.s3.us-west-1.amazonaws.com/co1SZT3RTYumCS8rU85uzt/IMG-20250502-WA0017.jpg'
    }, {
      property: 'og:image:width',
      content: '1200'
    }, {
      property: 'og:image:height',
      content: '630'
    }, {
      property: 'og:url',
      content: window.location.href
    },
    // Twitter Card tags
    {
      property: 'twitter:card',
      content: 'summary_large_image'
    }, {
      property: 'twitter:title',
      content: "Wing Foil - גלيشה וריחוף | ביץ' קלאב מעגן"
    }, {
      property: 'twitter:description',
      content: 'Wing Foil בכנרת - לעוף מעל המים'
    }, {
      property: 'twitter:image',
      content: 'https://uploadthingy.s3.us-west-1.amazonaws.com/co1SZT3RTYumCS8rU85uzt/IMG-20250502-WA0017.jpg'
    }];
    ogTags.forEach(tag => {
      let metaTag = document.querySelector(`meta[property="${tag.property}"]`);
      if (!metaTag) {
        metaTag = document.createElement('meta');
        metaTag.setAttribute('property', tag.property);
        document.head.appendChild(metaTag);
      }
      metaTag.setAttribute('content', tag.content);
    });
  }, []);
  return <div className="min-h-screen bg-white" dir="rtl" data-id="element-2325">
      <UtmCapture data-id="element-2326" />
      <Navigation data-id="element-2327" />

      {/* Hero Section */}
      <div className="relative h-[60vh] overflow-hidden" data-id="element-2328">
        <div className="absolute inset-0 bg-black/40 z-10" data-id="element-2329" />
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/co1SZT3RTYumCS8rU85uzt/IMG-20250502-WA0017.jpg" alt="Wing Foil Activity" className="w-full h-full object-cover" style={{
        objectPosition: '60% 38%',
        transform: 'scale(2.0)'
      }} data-id="element-2330" />
        <div className="absolute inset-0 z-20 flex flex-col items-center justify-center text-center text-white px-4" data-id="element-2331">
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="text-5xl md:text-7xl font-bold mb-4" data-id="element-2332">
            Wing Foil
          </motion.h1>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.1
        }} className="text-2xl md:text-3xl mb-2 font-medium" data-id="element-2333">
            ווינג פויל
          </motion.p>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.2
        }} className="text-xl md:text-2xl max-w-2xl font-light" data-id="element-2334">
            לעוף מעל המים - הדור הבא של גלisha
          </motion.p>
        </div>
      </div>

      {/* Content Section */}
      <div className="container mx-auto px-4 py-20" data-id="element-2335">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16" data-id="element-2336">
          <div data-id="element-2337">
            <h2 className="text-3xl font-bold text-[#0A5F8F] mb-6" data-id="element-2338">
              על הפעילות
            </h2>
            <p className="text-gray-600 text-lg leading-relaxed mb-8" data-id="element-2339">
              ה-Wing Foil הוא הספורט הימי החדשני ביותר שכבש את העולם. הוא משלב
              כנף (Wing) המוחזקת ביד וגלשן עם סנפיר (Foil) המאפשר ריחוף מעל
              המים. התחושה היא של שקט מוחלט ומהירות, כמעט ללא חיכוך עם המים.
              הכנרת, עם הרוחות היציבות שלה בשעות הצהריים, היא המקום המושלם ללמוד
              ולהתקדם בספורט זה.
            </p>

            {/* Perfect Spot Section */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="bg-gradient-to-br from-cyan-50 to-teal-50 border border-cyan-100 rounded-2xl p-6 mb-8" data-id="element-2340">
              <h3 className="text-2xl font-bold text-gray-900 mb-4 flex items-center gap-2" data-id="element-2341">
                <Wind className="w-7 h-7 text-cyan-600" data-id="element-2342" />
                חוף מושלם לגלישת Wing
              </h3>
              <div className="space-y-3 text-gray-700" data-id="element-2343">
                <p className="flex items-start gap-2" data-id="element-2344">
                  <Wind className="w-5 h-5 text-cyan-600 mt-0.5 shrink-0" data-id="element-2345" />
                  <span data-id="element-2346">
                    <strong data-id="element-2347">רוח צד (Side Shore)</strong> - תנאי רוח אידיאליים
                    לגלisha בטוחה
                  </span>
                </p>
                <p className="flex items-start gap-2" data-id="element-2348">
                  <Wind className="w-5 h-5 text-cyan-600 mt-0.5 shrink-0" data-id="element-2349" />
                  <span data-id="element-2350">
                    <strong data-id="element-2351">רוח יציבה כמעט כל יום</strong> במשך העונה
                    (אפריל-אוקטובר)
                  </span>
                </p>
                <p className="flex items-start gap-2" data-id="element-2352">
                  <MapPin className="w-5 h-5 text-cyan-600 mt-0.5 shrink-0" data-id="element-2353" />
                  <span data-id="element-2354">
                    <strong data-id="element-2355">חניה קרובה למים</strong> - נוחות מקסימלית
                  </span>
                </p>
                <p className="flex items-start gap-2" data-id="element-2356">
                  <Palmtree className="w-5 h-5 text-cyan-600 mt-0.5 shrink-0" data-id="element-2357" />
                  <span data-id="element-2358">
                    <strong data-id="element-2359">מדשאות</strong> לנוחות והכנת ציוד
                  </span>
                </p>
                <p className="flex items-start gap-2" data-id="element-2360">
                  <Package className="w-5 h-5 text-cyan-600 mt-0.5 shrink-0" data-id="element-2361" />
                  <span data-id="element-2362">
                    <strong data-id="element-2363">מתקן לטליית ווינגים וקומפרסור</strong>
                  </span>
                </p>
                <p className="flex items-start gap-2" data-id="element-2364">
                  <Music className="w-5 h-5 text-cyan-600 mt-0.5 shrink-0" data-id="element-2365" />
                  <span data-id="element-2366">
                    <strong data-id="element-2367">מוזיקה ופינת קפה</strong> - אווירה מושלמת
                  </span>
                </p>
                <p className="flex items-start gap-2" data-id="element-2368">
                  <Package className="w-5 h-5 text-cyan-600 mt-0.5 shrink-0" data-id="element-2369" />
                  <span data-id="element-2370">
                    <strong data-id="element-2371">אחסון ציוד</strong> - ניתן לאחסן את הציוד שלכם במקום
                  </span>
                </p>
              </div>
            </motion.div>

            <h3 className="text-2xl font-bold text-gray-800 mb-4" data-id="element-2372">
              יתרונות ה-Wing Foil
            </h3>
            <ul className="space-y-4 mb-8" data-id="element-2373">
              {['ציוד קל ונייד שקל להכין לפעילות', 'בטיחותי יותר מסוגי גלישות אחרים', 'עקומת למידה מהירה יחסית', 'תחושת ריחוף ייחודית וממכרת'].map((item, i) => <li key={i} className="flex items-center gap-3 text-gray-700" data-id="element-2374">
                  <div className="bg-cyan-100 p-1 rounded-full" data-id="element-2375">
                    <Rocket className="w-4 h-4 text-cyan-600" data-id="element-2376" />
                  </div>
                  {item}
                </li>)}
            </ul>
          </div>

          <div className="bg-gray-50 p-8 rounded-3xl border border-gray-100" data-id="element-2377">
            <h3 className="text-2xl font-bold text-[#0A5F8F] mb-6" data-id="element-2378">
              מה אנחנו מציעים?
            </h3>

            <div className="space-y-6" data-id="element-2379">
              <div className="flex gap-4" data-id="element-2380">
                <div className="bg-white p-3 rounded-xl shadow-sm h-fit" data-id="element-2381">
                  <ShieldCheck className="w-6 h-6 text-cyan-500" data-id="element-2382" />
                </div>
                <div data-id="element-2383">
                  <h4 className="font-bold text-lg mb-1" data-id="element-2384">
                    הדרכות אישיות ברמות שונות
                  </h4>
                  <p className="text-gray-600 text-sm" data-id="element-2385">
                    ליווי אישי מותאם לרמתך - ממתחילים מוחלטים ועד גולשים
                    מתקדמים.
                  </p>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-2386">
                <div className="bg-white p-3 rounded-xl shadow-sm h-fit" data-id="element-2387">
                  <Wind className="w-6 h-6 text-cyan-500" data-id="element-2388" />
                </div>
                <div data-id="element-2389">
                  <h4 className="font-bold text-lg mb-1" data-id="element-2390">הדרכות קבוצתיות</h4>
                  <p className="text-gray-600 text-sm" data-id="element-2391">
                    אימונים קבוצתיים באווירה תומכת ומעצימה, מחולקים לפי רמות.
                  </p>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-2392">
                <div className="bg-white p-3 rounded-xl shadow-sm h-fit" data-id="element-2393">
                  <Award className="w-6 h-6 text-cyan-500" data-id="element-2394" />
                </div>
                <div data-id="element-2395">
                  <h4 className="font-bold text-lg mb-1" data-id="element-2396">קהילה שוקקת</h4>
                  <p className="text-gray-600 text-sm" data-id="element-2397">
                    הצטרפו לקהילת גולשים פעילה ומגובשת שחולקת את אהבת המים.
                  </p>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-2398">
                <div className="bg-white p-3 rounded-xl shadow-sm h-fit" data-id="element-2399">
                  <Radio className="w-6 h-6 text-cyan-500" data-id="element-2400" />
                </div>
                <div data-id="element-2401">
                  <h4 className="font-bold text-lg mb-1" data-id="element-2402">
                    אירועי חתירה ספורטיביים
                  </h4>
                  <p className="text-gray-600 text-sm" data-id="element-2403">
                    חתירות וטיולים חוויתיים, שקיעה וזריחה, חציית הכנרת ועוד
                    מפגשים.
                  </p>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-2404">
                <div className="bg-white p-3 rounded-xl shadow-sm h-fit" data-id="element-2405">
                  <Package className="w-6 h-6 text-cyan-500" data-id="element-2406" />
                </div>
                <div data-id="element-2407">
                  <h4 className="font-bold text-lg mb-1" data-id="element-2408">אחסנת ציוד אישי</h4>
                  <p className="text-gray-600 text-sm" data-id="element-2409">
                    אפשרות לאחסון הציוד האישי שלכם במועדון בנוחות ובבטחה.
                  </p>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-2410">
                <div className="bg-white p-3 rounded-xl shadow-sm h-fit" data-id="element-2411">
                  <Wind className="w-6 h-6 text-cyan-500" data-id="element-2412" />
                </div>
                <div data-id="element-2413">
                  <h4 className="font-bold text-lg mb-1" data-id="element-2414">
                    שימוש חופשי בציוד המועדון
                  </h4>
                  <p className="text-gray-600 text-sm" data-id="element-2415">
                    חברי המועדון נהנים משימוש חופשי בציוד החתירה החדיש והאיכותי
                    של המועדון לחתירות עצמאיות.
                  </p>
                </div>
              </div>
            </div>

            <div className="mt-8 pt-8 border-t border-gray-200" data-id="element-2416">
              <Button className="w-full text-lg py-6" onClick={() => document.getElementById('contact')?.scrollIntoView({
              behavior: 'smooth'
            })} data-id="element-2417">
                רוצה להתחיל לעוף!
              </Button>
            </div>
          </div>
        </div>
      </div>

      {/* Campaign Banner */}
      <section className="py-16 bg-gradient-to-r from-cyan-600 to-blue-600 text-white text-center" data-id="element-2418">
        <div className="container mx-auto px-4" data-id="element-2419">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-2420">
            מבצע מיוחד למצטרפים חדשים!
          </h2>
          <p className="text-xl mb-8 opacity-90" data-id="element-2421">
            השאירו פרטים בדף הקמפיין שלנו וקבלו הצעה מיוחדת לשיעור היכרות
          </p>
          <a href="/wingfoil-campaign" className="inline-block bg-white text-cyan-600 font-bold text-lg py-4 px-10 rounded-full hover:bg-cyan-50 transition-colors shadow-lg hover:scale-105" data-id="element-2422">
            למעבר לדף המבצע והשארת פרטים ←
          </a>
        </div>
      </section>

      <ContactSection data-id="element-2423" />
      <Footer data-id="element-2424" />
    </div>;
}